export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            合作交流
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            投稿合作
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            欢迎漫画创作者、汉化组和版权方与布丁漫画网合作
          </p>
        </div>

        <div className="max-w-[640px] mx-auto">
          <div className="bg-background-100 border border-background-200/70 rounded-3xl p-8 md:p-10">
            <div className="flex flex-col md:flex-row gap-8">
              <div className="flex-1 space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-1">商务合作</h3>
                    <p className="text-sm text-foreground-500">bd@puddingcomic.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-send-plane-line text-accent-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-1">漫画投稿</h3>
                    <p className="text-sm text-foreground-500">submit@puddingcomic.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-answer-line text-secondary-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-1">意见反馈</h3>
                    <p className="text-sm text-foreground-500">feedback@puddingcomic.com</p>
                  </div>
                </div>
              </div>

              <div className="w-full md:w-[1px] bg-background-200 md:h-auto h-[1px]"></div>

              <div className="flex-1">
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  无论您是漫画作者、汉化团队还是版权代理方，布丁漫画网都欢迎您的加入。我们为创作者提供布丁漫画下拉式阅读技术支持和流量推广，让好作品被更多读者看到。
                </p>
                <a
                  href={`mailto:submit@puddingcomic.com`}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-send-line"></i>
                  立即联系
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}